import React from 'react';
import '../Footer/Footer.css';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MessageCircle } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section">
          <h3>About HomeCookt</h3>
          <p>Connecting food lovers with talented home cooks in your neighborhood. Experience authentic, homemade meals made with love.</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
            <li><Link to="/community-platform-policies">Community & Platform Policies</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Connect With Us</h3>
          <p>Follow us on social media for updates and delicious content.</p>
          <div className="social-links">
            <a 
              href="https://www.facebook.com/share/1JTzBnfzns/?mibextid=wwXIfr" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <Facebook size={24} />
            </a>
            <a 
              href="https://www.instagram.com/homecookt/profilecard/?igsh=MWJhend5bXp0ZmJjcA==" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <Instagram size={24} />
            </a>
            <a href="mailto:Homecookt.com@gmail.com" aria-label="Email" target="blank">
              <Mail size={24} />
            </a>
            <a 
              href="https://wa.me/447737024736" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <MessageCircle size={24} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-copyright">
        <p>© {new Date().getFullYear()} HomeCookt. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
